import {
    ENTRY_FEE,
    FIRST_PLACE_PRICE,
    FIRST_PLACE_PRICE_ELEVATED,
} from "../constants";

const initialPrizeForStrokeAlgorithm = (
    elevatedRound: boolean,
    isRound456: boolean
) => {
    if (elevatedRound && !isRound456) return 70000;
    if (elevatedRound && isRound456) return 80000;
    if (isRound456) return 50000;

    return 40000;
};

export const prizeCalculatorSeason2 = (
    playersCount: number,
    elevatedRound: boolean,
    isRound456: boolean
) => {
    const prizeList = [];

    if (playersCount < 10) {
        prizeList[0] = elevatedRound
            ? FIRST_PLACE_PRICE_ELEVATED
            : FIRST_PLACE_PRICE;
        return prizeList;
    }

    let prizeSum = 0;
    const RATIO = 1.3;
    const initialPrize = initialPrizeForStrokeAlgorithm(
        elevatedRound,
        isRound456
    );

    const totalPrize = initialPrize + ENTRY_FEE * playersCount;
    const remainder =
        totalPrize - (100 + 150 + 200 + 250 + 300 + 350) * playersCount * 0.05;

    for (let i = 0; i < playersCount; i++) {
        const RANK = i + 1;
        prizeList[i] = Math.round(
            ((RATIO - 1) * remainder) / Math.pow(RATIO, RANK)
        );
        const percentile = RANK / playersCount;
        if (percentile <= 0.05) prizeList[i] += 350;
        if (percentile > 0.05 && percentile <= 0.1) prizeList[i] += 300;
        if (percentile > 0.1 && percentile <= 0.15) prizeList[i] += 250;
        if (percentile > 0.15 && percentile <= 0.2) prizeList[i] += 200;
        if (percentile > 0.2 && percentile <= 0.25) prizeList[i] += 150;
        if (percentile > 0.25 && percentile <= 0.3) prizeList[i] += 100;
        if (percentile > 0.3) prizeList[i] = 0;
        if (i > 0 && prizeList[i] > 0) {
            prizeSum += prizeList[i];
        }
    }

    prizeList[0] = totalPrize - prizeSum;

    prizeList?.unshift(
        elevatedRound ? FIRST_PLACE_PRICE_ELEVATED : FIRST_PLACE_PRICE
    );
    return prizeList;
};